import { useAddresses } from '@entities/schedules';
import type React from 'react';
import { Location } from '@shared/assets';
import * as st from './styles.module.scss';

type Props = {
  id?: number;
  nullIndexValue?: string;
};

export const AddressIcon: React.FC<Props> = ({ id, nullIndexValue = '' }) => {
  const { addresses } = useAddresses();
  const addrNumber = addresses.findIndex((addr) => addr.id === id);
  return (
    <div className={st.icon}>
      <Location />
      <span className={st.number}>{addrNumber >= 0 ? addrNumber + 1 : `${nullIndexValue}`}</span>
    </div>
  );
};
